import makeService from './api';

export default makeService('ticket_actions');
